class ArticleDetail extends window.BAO.CustomElement() {
  static get styles () {
    return `:host { display: block; }`
  }

  connectedCallback () {
    super.connectedCallback()

    this.wrapImages()
  }

  wrapImages ({ wrapClass = 'rte-RichText_Image' } = {}) {
    const elements = window.BAO.Utils.getElements('img', { context: this })

    elements.forEach(image => {
      const alt = image.alt || ''
      const div = window.BAO.Utils.createElement('div', {
        class: wrapClass,
      })
      div.innerHTML = image.outerHTML

      if (alt !== '') {
        const caption = window.BAO.Utils.createElement('div', {
          class: 'rte-RichText_ImageCaption',
        })
        caption.textContent = alt

        div.innerHTML += caption.outerHTML
      }

      const rootElement = image.parentNode

      if (!rootElement) return
      rootElement.replaceChild(div, image)
    })
  }
}

if (!customElements.get('article-detail')) {
  customElements.define('article-detail', ArticleDetail)
}
